'use client';

import { useEffect, useState } from 'react';
import { BrandFacetViewModel, CategoryFacetViewModel, FacetValueViewModel } from '@/types/api';
import { IconSearchNormal } from '@/components/svg-symbols/icons';
import { ExpandablePanel } from './expandable-panel';
import { Checkbox, TextField } from '../form';
type ItemsType = BrandFacetViewModel[] | CategoryFacetViewModel[] | FacetValueViewModel[] | FacetValueViewModel[];
type ItemType = BrandFacetViewModel | CategoryFacetViewModel | FacetValueViewModel | FacetValueViewModel;
interface Props {
  items: ItemsType;
  title: string;
  defaultState?: 'open' | 'closed';
  showSearch?: boolean;
  onValueChange?: (selectedItems: ItemsType) => void;
  mode?: 'desktop' | 'mobile';
  uniqueKey: string;
  initialSelections?: ItemsType;
  sortFun?: (a: ItemType, b: ItemType) => number;
}
export function CheckboxList({
  items,
  title,
  defaultState,
  onValueChange,
  showSearch = false,
  mode,
  uniqueKey,
  initialSelections = [],
  sortFun
}: Props) {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [selectedItems, setSelectedItems] = useState<ItemsType>(initialSelections);
  const handleCheckboxChange = (item: FacetValueViewModel | BrandFacetViewModel | CategoryFacetViewModel, isSelected: boolean) => {
    if (!onValueChange) return;
    const newItem = {
      ...item,
      isSelected
    };
    let values: ItemsType = [];
    if (isSelected) {
      values = [...selectedItems, newItem];
    } else {
      // user has unchecked the item, remove it from list of selected items
      values = selectedItems.filter(filteredItem => filteredItem.key !== item.key);
    }
    setSelectedItems(values);
    onValueChange && onValueChange(values);
  };
  useEffect(() => {
    if (!items) return;
    const newSelectedItems = items.filter(item => item.isSelected);
    setSelectedItems(newSelectedItems);
  }, [items]);
  const filteredItems = items?.filter(item => item.displayNameFa?.toLowerCase().includes(searchTerm.toLowerCase()) || item.displayNameEn?.toLowerCase().includes(searchTerm.toLowerCase()))?.sort(sortFun);
  const searchBoxHolder = <TextField rightIcon={<IconSearchNormal className='h-6 w-6 text-text-mediumGray' />} id={uniqueKey} inputSize='medium' placeholder={title ? `جستجوی ${title}` : 'جست‌وجو'} onChange={e => setSearchTerm(e.target.value.trimStart())} value={searchTerm} fillInlineMessageSpace />;
  return <ExpandablePanel uniqueKey={`${uniqueKey}-${mode}-panel`} mode={mode} title={title} defaultState={defaultState} search={showSearch && searchBoxHolder} data-sentry-element="ExpandablePanel" data-sentry-component="CheckboxList" data-sentry-source-file="checkbox-list.tsx">
            <div className='flex w-full flex-col'>
                {!filteredItems.length ? <span className='px-4 py-2 text-caption-12 text-text-mediumGray'>نتیجه‌ای پیدا نشد!</span> : filteredItems?.map(item => <div key={item.key?.toString()} className='mobile-facet-divider relative flex items-center px-2 py-2.5 lg:px-4 lg:py-2'>
                            <Checkbox id={`${uniqueKey}-${item.displayNameFa}`} checkboxSize='large' customOnChange={e => handleCheckboxChange(item, e.target.checked)} checked={item.isSelected}>
                                {item.displayNameFa}
                            </Checkbox>
                        </div>)}
            </div>
        </ExpandablePanel>;
}